import { render, staticRenderFns } from "./ProfilesOverview.vue?vue&type=template&id=f8e686ca&scoped=true&"
import script from "./ProfilesOverview.vue?vue&type=script&lang=js&"
export * from "./ProfilesOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesOverview.vue?vue&type=style&index=0&id=f8e686ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e686ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable,VTextField})
